<template>
  <modal
    v-if="active"
    width="580px"
    :title="modalTitle"
    @close="close"
    :closeBtn="isAllowCloseButton"
    :logOutBtn="showLogOutButton"
    :actionBeforeLogout="actionBeforeLogout"
  >
    <template #default>
      <div class="text-center">
        <ui-icon size="64" :color="tachometerColor" :icon="`far ${tachometerIcon}`"></ui-icon>
        <div class="title">
          <b>{{ title }}</b>
        </div>
        <div class="text text-left" v-html="text"></div>
      </div>
    </template>

    <template #footer>
      <section class="justify-end xs12" style="display: flex">
        <ui-button
          v-if="cancelText"
          :text="cancelText"
          @click="close"
          :icon="cancelIcon"
        />
        <ui-button
          :text="t('Upgrade Subscription')"
          icon="fas fa-check"
          button-style="accent"
          @click="goToSubscription"
        />
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { useFreeEventsLimit } from '@/components/app-exceptions-resolver/dialogs/useFreeEventsLimit';

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  active,
  tachometerIcon,
  tachometerColor,
  title,
  modalTitle,
  text,
  cancelIcon,
  cancelText,
  isAllowCloseButton,
  showLogOutButton,
  close,
  goToSubscription,
  actionBeforeLogout,
} = useFreeEventsLimit(() => emit('close'));
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  margin: 13px 0 4px;
}
.text {
  font-size: 15px;
  :deep(button) {
    color: var(--color-blue) !important;
    text-decoration: underline !important;
  }
}
</style>
